(function () {
  'use strict';

  function initSection(section) {
    if (!section) return;

    if (section.dataset.contactVisualInitialized === 'true') {
      return;
    }

    section.dataset.contactVisualInitialized = 'true';

    section.querySelectorAll('[data-copy-email]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var email = button.dataset.copyEmail || '';

        if (!email) return;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(email);
          } else {
            var input = document.createElement('textarea');

            input.value = email;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';

            document.body.appendChild(input);

            input.select();

            document.execCommand('copy');

            input.remove();
          }

          button.dataset.copied = 'true';

          window.setTimeout(function () {
            delete button.dataset.copied;
          }, 1600);
        } catch (error) {
          button.dataset.copied = 'false';
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches('.contact-us-visual')
    ) {
      initSection(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll('.contact-us-visual')
        .forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
